// change-password form, .update-email form
$('body').on('submit', '.setting form', function() {
    var $this = $(this);    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
    
    var error = false;
    var card = $this.parents('.card');
    card.find('.required').each(function() {
        var input = $(this);

        if(input.attr('type') === 'radio') {
            if(!card.find('input[name="'+input.attr('name')+'"]:checked').length) {
                error = true;
            }
        }

        if(input.attr('type') === 'checkbox') {
            if(!input.prop('checked')) {
                error = true;
            }
        }

        if(input.val() === '') {
            error = true;
        }
    });

    if(error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }
    
    loading();
    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
            console.log(data);
            unloading();

            if(!data.success) {
                showError('Error', data.message);
                return false;
            }

            closeModal();
            addNotification(data.notification.title, data.notification.message, data.notification.icon);
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});

function ucwords(string) {
    string = string.toLowerCase();
    return string.replace(/(^([a-zA-Z\p{M}]))|([ -][a-zA-Z\p{M}])/g,
        function ($1) {
            return $1.toUpperCase();
        });
}

function hookItem(hooks, status) {
    var options = '';
    $.each(hooks, function(hook, value) {
        // TODO update the replace 
        var parsed = hook.replace("_", " ");
        parsed = parsed.replace("_", " ");
        parsed = parsed.replace("_", " ");
        parsed = parsed.replace("_", " ");
        parsed = parsed.replace("_", " ");
        parsed = ucwords(parsed);
        console.log(value);

        options += `<option value="${hook}">${parsed}</option>`;
    });
    return `<div class="hook-item item" data-status="${status}">
        <a href="" class="remove-hook-item-trigger remove-item-trigger icon-trash" tabindex="-1"></a>
        <a href="" class="add-hook-item-trigger-before add-item-before-trigger icon-add" tabindex="-1"></a>

        <ul class="fields no-padding">
            <li class="filled">
                <select name="hook[${status}][]" class="input required">
                    <option value="">Select Hook</option>
                    ${options}
                </select>
                <span>Hook</span>
            </li>
        </ul>
    </div>`;
}

$('body').on('click', '.status-hooks .add-hook-item-trigger', function () {
    var $this = $(this);
    var hook = $this.parents('.status-hook');
    var hooks = JSON.parse($this.parents('.status-hooks').attr('data-hooks'));
    hook.find('.setup-items').append(hookItem(hooks, hook.attr('data-status')));
    return false;
});

$('body').on('click', '.status-hooks .add-hook-item-trigger-before', function () {
    var $this = $(this);
    var hook = $this.parents('.status-hook');
    var hooks = JSON.parse($this.parents('.status-hooks').attr('data-hooks'));
    $this.parents('.hook-item').before(hookItem(hooks, hook.attr('data-status')));
    return false;
});

$('body').on('click', '.remove-hook-item-trigger', function () {
    var $this = $(this);
    $this.parents('.hook-item').remove();
    return false;
});







// message
var message = `<div class="message">
    <a href="" class="remove-message-trigger icon-trash" tabindex="-1"></a>
    <a href="" class="add-message-trigger-before icon-add" tabindex="-1"></a>

    <ul class="fields no-padding">
        <li class="third filled">
            <select name="color[]" class="input required">
                <option value="">Select Color</option>
                <option value="blue">Blue</option>
                <option value="white">White</option>
            </select>
            <span>Color</span>
        </li>

        <li class="third-x2 filled last">
            <input type="text" name="message[]" class="required" value="">
            <span>Message</span>
        </li>
    </ul>
</div>`;

$('body').on('click', '.add-message-trigger', function () {
    var $this = $(this);
    var card = $this.parents('.card');

    var color = card.find('.message').last().find('[name="color[]"]').val();
    card.find('.setup-messages').append(message);

    if (color) {
        card.find('.message').last().find('[name="color[]"]').val(color == 'white' ? 'blue' : 'white');
    }
    return false;
});

$('body').on('click', '.add-message-trigger-before', function () {
    var $this = $(this);
    var color = $this.parents('.message').find('[name="color[]"]').val();
    console.log(color);
    $this.parents('.message').before(message);
    $this.parents('.message').prev().find('[name="color[]"]').val(color == 'white' ? 'blue' : 'white');
    return false;
});

$('body').on('click', '.remove-message-trigger', function () {
    var $this = $(this);
    $this.parents('.message').remove();
    return false;
});

$('body').on('keydown', 'input[name="message[]"]', function (e) {
    if (e.keyCode === 9) {
        var $this = $(this);
        if ($this.parents('.message').is(':last-child')) {
            e.preventDefault();
            var card = $this.parents('.card');
            card.find('.add-message-trigger').trigger('click');
            $this.parents('.message').next().find('input[type="text"]').focus();

            // var color = $this.parents('.message').find('[name="color[]"]').val();
            // if (color) {
            //     $this.parents('.message').next().find('[name="color[]"]').val(color == 'white' ? 'blue' : 'white');
            // }
        }
    }
});

function followUpEmail(element) {
    if(!element.length) {
        return '';
    }
    var email = JSON.parse(element.attr('data-email'));

    var options = ``;
    $.each(email, function(index, value) {
        options += `<option value="${value}">${value}</option>`;
    });

    return options;
}

function followUpEmailTemplates(element) {
    if (!element.length) {
        return '';
    }
    var emailTemplates = JSON.parse(element.attr('data-email_templates'));

    var options = ``;
    $.each(emailTemplates, function (index, data) {
        options += `<option value="${data.email_template}">${data.name}</option>`;
    });

    return options;
}

// contact follow up
var contactFollowUp = `<div class="contact-follow-up-email">
    <a href="" class="remove-contact-follow-up-email-trigger icon-trash" tabindex="-1"></a>
    <a href="" class="add-contact-follow-up-email-trigger-before icon-add" tabindex="-1"></a>

    <ul class="fields no-padding">
        <li class="filled third">
            <input type="tel" name="interval[]" class="required focus">
            <span>Interval</span>
        </li>

        <li class="filled third">
            <select name="email[]" class="input required">
                <option value="">Select Option</option>
                ${followUpEmail($('.contact-follow-up'))}
            </select>
            <span>Email</span>
        </li>

        <li class="filled third last">
            <select name="email_template[]" class="input required">
                <option value="">Select Option</option>
                ${followUpEmailTemplates($('.contact-follow-up'))}
            </select>
            <span>Template</span>
        </li>
    </ul>
</div>`;

$('body').on('click', '.setting .add-contact-follow-up-email-trigger', function () {
    var $this = $(this);
    var setting = $this.parents('.setting');
    setting.find('.setup-contact-follow-up-email').append(contactFollowUp);
    return false;
});

$('body').on('click', '.setting .add-contact-follow-up-email-trigger-before', function () {
    var $this = $(this);
    // var setting = $this.parents('.setting');
    $this.parents('.contact-follow-up-email').before(contactFollowUp);
    return false;
});

$('body').on('click', '.remove-contact-follow-up-email-trigger', function () {
    var $this = $(this);
    $this.parents('.contact-follow-up-email').remove();
    return false;
});

$('body').on('keydown', '.setting.contact-follow-up .tab-next', function (e) {
    if (e.keyCode === 9) {
        var $this = $(this);
        if ($this.parents('.contact-follow-up-email').is(':last-child')) {
            e.preventDefault();
            var setting = $this.parents('.setting');
            setting.find('.add-contact-follow-up-email-trigger').trigger('click');
            $this.parents('.contact-follow-up-email').next().find('.focus').focus();
        }
    }
});

// story follow up
var storyFollowUp = `<div class="story-follow-up-email">
    <a href="" class="remove-story-follow-up-email-trigger icon-trash" tabindex="-1"></a>
    <a href="" class="add-story-follow-up-email-trigger-before icon-add" tabindex="-1"></a>

    <ul class="fields no-padding">
        <li class="filled third">
            <input type="tel" name="interval[]" class="required focus">
            <span>Interval</span>
        </li>

        <li class="filled third">
            <select name="email[]" class="input required">
                <option value="">Select Option</option>
                ${followUpEmail($('.story-follow-up'))}
            </select>
            <span>Email</span>
        </li>

        <li class="filled third last">
            <select name="email_template[]" class="input required">
                <option value="">Select Option</option>
                ${followUpEmailTemplates($('.story-follow-up'))}
            </select>
            <span>Template</span>
        </li>
    </ul>
</div>`;

$('body').on('click', '.setting .add-story-follow-up-email-trigger', function () {
    var $this = $(this);
    var setting = $this.parents('.setting');
    setting.find('.setup-story-follow-up-email').append(storyFollowUp);
    return false;
});

$('body').on('click', '.setting .add-story-follow-up-email-trigger-before', function () {
    var $this = $(this);
    // var setting = $this.parents('.setting');
    $this.parents('.story-follow-up-email').before(storyFollowUp);
    return false;
});

$('body').on('click', '.remove-story-follow-up-email-trigger', function () {
    var $this = $(this);
    $this.parents('.story-follow-up-email').remove();
    return false;
});

$('body').on('keydown', '.setting.story-follow-up .tab-next', function (e) {
    if (e.keyCode === 9) {
        var $this = $(this);
        if ($this.parents('.story-follow-up-email').is(':last-child')) {
            e.preventDefault();
            var setting = $this.parents('.setting');
            setting.find('.add-story-follow-up-email-trigger').trigger('click');
            $this.parents('.story-follow-up-email').next().find('.focus').focus();
        }
    }
});